module.exports = __webpack_public_path__ + "static/avatar-mj-c2a83205c897dc1bccb3df9b9f3137da.png";